// Spinner.js
import React from 'react';
// import './Spinner.css'; // Import the CSS file for styling

const Spinner = () => {
  return (
    <div className="spinner-container">
      <div className="spinner"></div>
    </div>
  );
};

export default Spinner;